// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"186":"component---src-lekoarts-gatsby-theme-styleguide-template-tsx","351":"commons","385":"component---src-template-tsx"}[chunkId] + "-" + {"186":"cd41a8c4cc288a27d981","351":"407c28806aa6d4fadeb9","385":"66c76262f66895caaa9f"}[chunkId] + ".js";
};